import { render, staticRenderFns } from "./ProgramTable.vue?vue&type=template&id=13137946"
import script from "./ProgramTable.vue?vue&type=script&lang=js"
export * from "./ProgramTable.vue?vue&type=script&lang=js"
import style0 from "./ProgramTable.vue?vue&type=style&index=0&id=13137946&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports